import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setGetStreamClient, setGetStreamClientStatus } from '@/app/store/actions/getstream';
import { StreamChat } from 'stream-chat';
import secureLocalStorage from 'react-secure-storage';

const ChatClient = () => {
	const user = useSelector(({ auth }) => auth.user);
	const client = useSelector(({ getstream }) => getstream.getstream.client);
	const dispatch = useDispatch();

	useEffect(() => {
		let clientInstance;
		const initClient = async () => {
			// Disconnect any existing client instance
			if (client) {
				dispatch(setGetStreamClientStatus('disconnecting'));
				await client.disconnectUser();
			}

			// If no chat credentials, clear and exit
			if (!user.data.chat_user_id || !user.data.chat_token) {
				dispatch(setGetStreamClient(null));
				return;
			}
			dispatch(setGetStreamClientStatus('connecting'));
			try {
				const chatId = user.data.chat_user_id;
				const chatToken = user.data.chat_token;
				// Always use a fresh StreamChat instance
				clientInstance = new StreamChat(import.meta.env.VITE_GETSTREAM_API_KEY);
				await clientInstance.connectUser(
					{
						id: chatId,
						name: user.data.name,
					},
					chatToken
				);
				dispatch(setGetStreamClient(clientInstance));
				dispatch(setGetStreamClientStatus('connected'));
			} catch (error) {
				console.error('Error connecting to GetStream Chat:', error);
				dispatch(setGetStreamClient(null));
				dispatch(setGetStreamClientStatus('error'));
			}
		};

		initClient();

		return () => {
			if (clientInstance) {
				clientInstance.disconnectUser();
				dispatch(setGetStreamClient(null));
			}
		};
	}, [user.data.chat_user_id, user.data.chat_token]);

	return null;
};

export default ChatClient;
